export default function (doc) { return null }
